module.exports = __webpack_public_path__ + "static/media/Hero.a52c2042.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/Hero.jpg
// module id = 3743
// module chunks = 0